<div class="card to-be-billed" style="height: 100%">
  <div class="card-header" i18n="@@UsersTransactionsSettleUpHeader">
    <h5>
      <app-svg source="icons/feather/zap" height="18"></app-svg>
      Ladevorgänge von Benutzern abrechnen
    </h5>
  </div>

  <div class="card-body">
    <div id="open-invoices-table">
      <!-- <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" [class]="tableFunctions.getTableLayout(className)"></app-table> -->
      <table *ngIf="isTableReady" class="table">
        <thead>
          <tr style="border-bottom: 1px solid #ced4da">
            <th *ngFor="let column of tableColumns" [class]="column.property">{{ column.columnDescription }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entity of entities" class="linkTableRow" [routerLink]="['create', entity.userId]">
            <td *ngFor="let column of tableColumns" [class]="column.property">
              {{ isDate(entity[column.property]) ? parseDate(entity[column.property]) : entity[column.property] }}
            </td>
          </tr>
          <tr *ngIf="entities.length < 1">
            <td attr.colspan="{{ tableColumns.length }}" class="h-100 text-center align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><br />
              <span class="pt-3">Keine Einträge vorhanden.</span>
            </td>
          </tr>
        </tbody>
      </table>
    
      <div *ngIf="!isTableReady" class="loading-spinner-container">
        <div class="spinner-border text-primary loading-spinner-md" role="status">
          <span class="visually-hidden-focusable">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
